import { isDefined } from "@utils/helpers";

import { StoreDetailsModel } from "@redux/modules/api/data/stores/@types/storeDetails.model";

import { StorePickerStore } from "../types/storePickerStore.types";

const getStoreCoordinates = (
    store: StoreDetailsModel,
): woosmap.map.LatLngLiteral => ({
    lat: store.latitude,
    lng: store.longitude,
});

const getDistancePromiseForStoreIndex = (
    distanceElementsPromise:
        | Promise<woosmap.map.distance.DistanceMatrixElement[] | undefined>
        | undefined,
    index: number,
) =>
    distanceElementsPromise?.then(distanceElements => {
        const distanceMatrixElement = distanceElements?.at(index);
        if (distanceMatrixElement?.status !== "OK") return undefined;

        return distanceMatrixElement.distance.value;
    });

export const enrichStores = (
    stores: Array<StoreDetailsModel>,
    origin?: woosmap.map.LatLngLiteral,
    distanceService?: woosmap.map.DistanceService,
): Array<StorePickerStore> => {
    const withDistance = isDefined(origin) && isDefined(distanceService);

    const distanceElementsPromise = withDistance
        ? distanceService
              .getDistanceMatrix({
                  origins: [origin],
                  destinations: stores.map(getStoreCoordinates),
                  method: "distance",
                  elements: "distance",
              })
              .then(({ rows }) => rows.at(0)?.elements)
        : undefined;

    return stores.map((store, index) => ({
        ...store,
        distancePromise: getDistancePromiseForStoreIndex(
            distanceElementsPromise,
            index,
        ),
    }));
};
